export default "__VITE_ASSET__C8V1aQWw__"